/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: 转人工轮训拉取用户消息接口
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-05-15 21:25:11
 * @LastEditTime: 2023-01-07 22:21:11
 * @FilePath: /client-h5-v2/src/apis/dialog/pullMessageTestNow.ts
 */
import httpRequest from '@/request/index'
import { DialogPullMessageParamsTestNow } from '@/apis/types'

export function apiGetDialogPullMessageTestNow (param: DialogPullMessageParamsTestNow) {
  return httpRequest({
    url: '/api/v1/deviceHelp/pullMessage',
    method: 'post',
    data: param
  })
}
